"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delayedRedirect = void 0;

var _redirect = _interopRequireDefault(require("@insided/deprecated-utils/redirect"));

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var delayedRedirect = function delayedRedirect(url) {
  var _resolveUrl;

  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var resolved = (_resolveUrl = (0, _absoluteUrlRuntime.resolveUrl)(url)) !== null && _resolveUrl !== void 0 ? _resolveUrl : url; // eslint-disable-next-line no-console

  console.log("[delayedRedirect] Redirecting to ".concat(resolved));
  setTimeout(function () {
    (0, _redirect.default)(resolved);
  }, delay);
};

exports.delayedRedirect = delayedRedirect;